var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.907px",
    height: "15.907px",
    viewBox: "0 0 15.907 15.907",
    enableBackground: "new 0 0 15.907 15.907",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-medal",
    fill: "#F0C787",
    d: "M6.952,4.062L4.8,0.483C4.621,0.185,4.299,0.001,3.951,0H0.5 C0.224,0.002,0.002,0.228,0.004,0.504C0.005,0.603,0.035,0.7,0.091,0.782l3.457,4.938C4.49,4.839,5.677,4.261,6.952,4.062z  M15.409,0h-3.453c-0.35-0.001-0.676,0.183-0.855,0.483L8.956,4.062c1.274,0.199,2.459,0.777,3.4,1.658l3.461-4.938 c0.156-0.229,0.098-0.539-0.131-0.695C15.604,0.031,15.508,0.001,15.409,0z M7.954,4.971c-3.02,0-5.468,2.448-5.468,5.468 c0,3.021,2.448,5.468,5.468,5.468s5.468-2.447,5.468-5.468C13.422,7.419,10.974,4.971,7.954,4.971L7.954,4.971z M10.829,9.857 L9.65,11.004l0.279,1.623c0.031,0.194-0.101,0.377-0.296,0.408c-0.076,0.013-0.154,0-0.223-0.035l-1.457-0.767L6.5,13 c-0.175,0.09-0.391,0.023-0.481-0.152c-0.036-0.068-0.048-0.147-0.036-0.225l0.279-1.621L5.079,9.857 C4.938,9.719,4.935,9.493,5.073,9.352c0.056-0.057,0.128-0.094,0.206-0.104L6.908,9.01l0.728-1.475 c0.088-0.177,0.302-0.249,0.479-0.162c0.07,0.035,0.127,0.092,0.162,0.162L9,9.01l1.629,0.238c0.195,0.027,0.331,0.207,0.304,0.402 C10.922,9.729,10.885,9.801,10.829,9.857L10.829,9.857z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.5b6f6b79.svg";
export { ForwardRef as ReactComponent };